import { authFeature } from './auth.reducer';
import { createSelector } from '@ngrx/store';

export const { selectUser: selectUserEntity, selectRoles: selectRolesEntity, selectLicences: selectLicenseEntity, selectPermissions: selectPermissionsEntity } = authFeature;

export const selectUser = createSelector(selectUserEntity, (user) => user?.entity);
export const selectUserRole = createSelector(selectUser, (user) => user?.role);
export const selectRoles = createSelector(selectRolesEntity, (role) => role?.entity);
export const selectLicences = createSelector(selectLicenseEntity, (licence) => licence?.entity);
export const selectPermissions = createSelector(selectPermissionsEntity, (permissions) => permissions?.entity);

export const selectOperationPermissions = createSelector(
  selectPermissions,
  (permissions): Record<string, number> =>
    ((permissions && permissions[0]?.operationPermissions) || []).reduce(
      (permissionMap, { operation, permission }) => {
        permissionMap[operation] = permission;
        return permissionMap;
      },
      {} as Record<string, number>,
    ),
);
export const selectUserAndPermissions = createSelector(selectUser, selectOperationPermissions, (user, permissions) => {
  return { user, permissions };
});
